import { render, staticRenderFns } from "./CheckPrice.vue?vue&type=template&id=1b1b3119&scoped=true&"
import script from "./CheckPrice.vue?vue&type=script&lang=js&"
export * from "./CheckPrice.vue?vue&type=script&lang=js&"
import style0 from "./CheckPrice.vue?vue&type=style&index=0&id=1b1b3119&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1b3119",
  null
  
)

export default component.exports